import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=17c8491c&scoped=true&"
import script from "./SimpleTable.vue?vue&type=script&lang=js&"
export * from "./SimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=17c8491c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8491c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c8491c')) {
      api.createRecord('17c8491c', component.options)
    } else {
      api.reload('17c8491c', component.options)
    }
    module.hot.accept("./SimpleTable.vue?vue&type=template&id=17c8491c&scoped=true&", function () {
      api.rerender('17c8491c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/SimpleTable.vue"
export default component.exports